import React from 'react'
import Menu from"./Menu"
import { useIntl } from "gatsby-plugin-intl"


export default function Navbar() {
    const intl = useIntl();
    return (
        <div>
            <Menu id="topNav" ariaLabel={intl.formatMessage({ id: "accessibility3" })} />
        </div>
    )
}
